import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {connect} from 'pwa-helpers';
import store from '../../store';


@customElement('shared-specsheet-page')
export class SharedSpecsheetPage extends connect(store)(LitElement) {

	static styles = css`
		:host {
			background-color: #fff;
			color: #000;
			margin: 40px auto 20px auto;
			overflow: hidden;
			position: relative;
			box-sizing: border-box;
			page-break-after: always;
			//border: 1px solid black;
			//min-width: 210mm;
			//height: auto;

			width: 100%;
			// height: auto;
			//min-height: 297mm;
			display: flex;
			justify-content: start;
			flex-direction: column;
			aspect-ratio: 210/297;
			padding: 4cqw 5cqw 2cqw 5cqw;
		}

		@media print {
			:host {
				width: 210mm;
				height: 297mm;
				border: none;
				overflow: hidden;
				margin-bottom: 0;
			}
		}
	`;

	@property({type: String})
	headLabel = 'Specsheet';

	@property({type: String})
	title = null;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.lang = state.status.lang;
	}
	render() {
		return html`
			<shared-specsheet-head headLabel="${this.headLabel}" title="${this.title}"></shared-specsheet-head>
			<slot></slot>
			<shared-specsheet-footer></shared-specsheet-footer>
		`;
	}
}
